export const columnLayout = [
  {
    dataField: "systemCd",
    headerText: "시스템구분코드",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantCd1",
    headerText: "사업장구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantCd",
    headerText: "사업장구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantCdNm",
    headerText: "사업장",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vhclSeq",
    headerText: "차량식별순번",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vhclNo",
    headerText: "차량번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemCd",
    headerText: "사전등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemCdNm",
    headerText: "사전등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemEtcCd",
    headerText: "비고1",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemEtcCdNm",
    headerText: "비고1",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemEtcRmks",
    headerText: "비고2",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemEtcRmksNm",
    headerText: "비고2",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspRmks",
    headerText: "검수원비고",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrCd",
    headerText: "공급업체 코드",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrNm",
    headerText: "공급업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "rvndrCd",
    headerText: "실공급업체 코드",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "rvndrNm",
    headerText: "실공급업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "scrapAreaCd",
    headerText: "하차지",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "tmsOdrNo",
    headerText: "배차번호",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "wghtDt",
    headerText: "입고일자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "wssId",
    headerText: "계근번호",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inptDt",
    headerText: "계근일자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "transCd",
    headerText: "운송구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "drivTel4",
    headerText: "전화번호뒤4자리",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaCd",
    headerText: "상차지 코드",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaNm",
    headerText: "상차지명",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaAddr",
    headerText: "주소",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaAddrDesc",
    headerText: "주소상세",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "vhclSeq",
    headerText: "차량식별순번",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "drivNm",
    headerText: "운전자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "drivTel",
    headerText: "전화번호",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "totalWeight",
    headerText: "총중량",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCnt",
    headerText: "경고/반품횟수",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
];
